// import textBalancer from 'text-balancer'
import * as balanceText from 'balance-text'

export default class {
  constructor(){
    this.create()
  }

  create() {
    balanceText('.balance-text', {watch: true})
  }

  cleanup() {
    balanceText('.balance-text', {watch: false})
  }

}
